// extracted by mini-css-extract-plugin
export default {"avatar":"avatar_avatar__1jixk","md":"avatar_md__0bPGS","sm":"avatar_sm__zCXZA","xl":"avatar_xl__f5iWu"};